export default "__VITE_ASSET__rgmxtVaN__"